import { clickupAPI } from '../../utils/api/clickup';
import { useState, useEffect } from 'react';

const useTaskComments = (taskID) => {
  const [taskComments, setTaskComments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchComments = async () => {
      if (!taskID) return;
 
      setLoading(true);
      try {
        const response = await clickupAPI({action: 'getTaskComments', taskId: taskID}); 
        setTaskComments(response);
      } catch (err) {
        console.error('Error fetching ClickUp task comments:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchComments();
  }, [taskID]);

  return { taskComments, loading, error };
};

export default useTaskComments;
